import VideoCarousel, { VideoCarouselProps } from "./VideoCarousel";

export { VideoCarousel, VideoCarouselProps };

export default VideoCarousel;
